import React, { useEffect } from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { HeaderActionCart } from './Cart/headerActionCart';
import { HeaderActionHelp } from './Help';
import { DropdownPopover } from '../../../Overlays/Dropdown';
import { formatContentfulComponentProps } from '../../../../../utils/globals';
import { Notifications } from '../../../../Marketing/Notifications/notifications';
import { sidebarState } from '../../../../../utils/recoil/sidebar';
import { Form } from '../../../Forms/Form/form';
import { formLabelsState } from '../../../../../utils/recoil/formLabels';
import { withAuth } from '../../../../../utils/hocs/withAuth';
import { Button } from '../../../Elements';
import { useDrawer } from '../../../../../utils/recoil/drawer';

const HelpButton = () => (
  <Button
    isCircular
    color={{ classname: 'primary' }}
    className='relative'
    icon={{ iconKey: 'HiOutlineQuestionMarkCircle', size: 'xl' }}
  />
);

const NotificationButton = () => {
  const hasSeenNotifications =
    typeof window !== 'undefined' && window.localStorage.has_seen_notifications;

  return (
    <div className='relative'>
      <Button
        isCircular
        color={{ classname: 'primary' }}
        icon={{ iconKey: 'HiOutlineBell', size: 'xl' }}
        className='relative'
      />
      {!hasSeenNotifications && (
        <span className='w-3 h-3 -top-1 -right-0 absolute rounded-full bg-red-500' />
      )}
    </div>
  );
};

const PureHeaderActions = withAuth(
  ({
    notifications,
    help,
    login,
    profile,
    form,
    onLoginSubmit,
    user,
    isLoading,
  }) => {
    const [formLabels, setFormlabels] = useRecoilState(formLabelsState);
    const drawer = useDrawer();
    const { errorLabels, successLabels } = form;

    useEffect(() => {
      // Set the form labels success & error messages to the ones from the contentful component
      setFormlabels({
        ...formLabels,
        successLabels: successLabels[0].text,
        errorLabels: errorLabels[0].text,
      });
    }, []);

    return (
      <div className='flex items-center'>
        <div className='relative hidden sm:ml-3 lg:flex sm:items-center'>
          <DropdownPopover button={NotificationButton}>
            <Notifications {...formatContentfulComponentProps(notifications)} />
          </DropdownPopover>
        </div>
        <div className='relative hidden md:ml-3 lg:flex sm:items-center'>
          <DropdownPopover button={HelpButton}>
            <HeaderActionHelp {...formatContentfulComponentProps(help)} />
          </DropdownPopover>
        </div>
        <div className='relative hidden sm:ml-3 lg:flex sm:items-center'>
          {user.email ? (
            <Button
              {...profile}
              isCircular
              label={null}
              color={{ classname: 'primary' }}
              icon={{ iconKey: 'HiOutlineUserCircle', size: 'xl' }}
              className='relative'
            />
          ) : (
            <Button
              {...login}
              slug={undefined}
              onClick={() =>
                drawer.open({
                  body: (
                    <div className='p-4 w-full'>
                      <Form
                        {...form}
                        isLoading={isLoading}
                        onSubmit={onLoginSubmit}
                      />
                    </div>
                  ),
                  placement: 'right',
                  width: 'lg:w-screen/3 w-screen-95',
                })
              }
              isCircular
              label={null}
              color={{ classname: 'primary' }}
              icon={{ iconKey: 'HiOutlineUserCircle', size: 'xl' }}
              className='relative'
            />
          )}
        </div>
        {/* right element */}
        <div className='sm:ml-3 sm:flex sm:items-center'>
          <HeaderActionCart
            placement='right'
            quantity={2}
          />
        </div>
      </div>
    );
  }
);

export const HeaderActions = (props) => (
  <PureHeaderActions {...formatContentfulComponentProps(props)} />
);
